










































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CardData } from '@/types/cardData';

@Component({
  name: 'EditCard',
  components: {},
})

export default class EditCard extends Vue {
  @Prop({ type: Object, required: true }) public taskCardToEdit!: CardData;

  public dialog: boolean = false;
  public titleField: string = this.taskCardToEdit.title;
  public descriptionField: string = this.taskCardToEdit.value;
  public taskDateField: string = this.taskCardToEdit.date;
  public dateField: boolean = false;
  public taskPriority: boolean = this.taskCardToEdit.is_main;
  public selection: number = 0;

  public closeModal(): any {
    this.dialog = false;
  }

  public saveEditData(): any {
    this.dialog = false;
    this.taskCardToEdit.title = this.titleField;
    this.taskCardToEdit.value = this.descriptionField;
    this.taskCardToEdit.date = this.taskDateField;
    this.taskCardToEdit.is_main = this.taskPriority;
  }

}

